module.exports = __webpack_public_path__ + "static/media/mariana.6b577104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/mariana.jpg
// module id = 345
// module chunks = 0